import Component from "./component"
import Header from "../performance/header"

export default {
  Component,
  Header,
}
